import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import useIsMobile from "../hooks/useIsMobile";
import { useUserAuth } from "../context/UserAuthContext";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChatIcon from "@mui/icons-material/Chat";
import GroupIcon from "@mui/icons-material/Group";
import PaymentIcon from "@mui/icons-material/Payment";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../img/logo.png";

const AppLayout = ({ children, fullWidth = false }) => {
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const location = useLocation();
    const { logOut, isAdmin } = useUserAuth();

    const handleLogout = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (err) {
            console.error(err);
        }
    };

    const navItems = [
        { label: "Dashboard", icon: DashboardIcon, path: "/auth" },
        { label: "Chat", icon: ChatIcon, path: "/chat" },
        ...(isAdmin ? [{ label: "Team", icon: GroupIcon, path: "/team" }] : []),
        { label: "Billing", icon: PaymentIcon, path: "/billing" },
    ];

    const isActive = (path) => {
        if (path === "/auth") return location.pathname === "/auth";
        return location.pathname.startsWith(path);
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            ...(isMobile
                ? { height: "100dvh", overflow: "hidden" }
                : fullWidth
                    ? { height: "100vh", overflow: "hidden" }
                    : { minHeight: "100vh" }),
        }}>
            {!isMobile && <Sidebar open onClose={() => {}} />}

            {isMobile && (
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "6px 12px",
                    backgroundColor: "#1c0943",
                    flexShrink: 0,
                    height: "44px",
                    boxSizing: "border-box",
                }}>
                    <img src={logo} alt="Logo" style={{ height: "22px" }} />
                    <button
                        onClick={handleLogout}
                        style={{
                            width: "32px",
                            height: "32px",
                            border: "none",
                            borderRadius: "8px",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "rgba(255,255,255,0.6)",
                        }}
                    >
                        <LogoutIcon style={{ fontSize: "20px" }} />
                    </button>
                </div>
            )}

            <main style={{
                flex: 1,
                backgroundColor: "#f5f5f7",
                overflow: isMobile && fullWidth ? "hidden" : "auto",
                minHeight: 0,
                ...(isMobile ? { WebkitOverflowScrolling: "touch", overscrollBehavior: "contain" } : {}),
            }}>
                {fullWidth
                    ? <div style={{ height: "100%" }}>{children}</div>
                    : <div style={{ padding: isMobile ? "16px" : "32px 40px", maxWidth: "960px" }}>{children}</div>
                }
            </main>

            {isMobile && (
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-around",
                    backgroundColor: "#fff",
                    borderTop: "1px solid #e0e0e0",
                    flexShrink: 0,
                    paddingTop: "6px",
                    paddingBottom: "calc(6px + env(safe-area-inset-bottom, 0px))",
                }}>
                    {navItems.map((item) => {
                        const active = isActive(item.path);
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.path}
                                onClick={() => navigate(item.path)}
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: "2px",
                                    border: "none",
                                    backgroundColor: "transparent",
                                    cursor: "pointer",
                                    padding: "4px 12px",
                                    color: active ? "#825ee7" : "#999",
                                    fontSize: "11px",
                                    fontWeight: active ? 600 : 400,
                                    transition: "color 0.15s",
                                }}
                            >
                                <Icon style={{ fontSize: "22px" }} />
                                {item.label}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default AppLayout;
